import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {FinalBsiComponent} from "./final-bsi.component";

const routes: Routes = [
  {
    path: 'final-bsi',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: FinalBsiComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinalBsiRoutingModule { }
